<h2 mat-dialog-title>Seleccionar métrica</h2>
<div mat-dialog-content>
  <mat-form-field appearance="fill" class="search-field">
    <mat-label>Buscar métrica</mat-label>
    <input matInput [value]="search()" (input)="onSearch($event)" />
  </mat-form-field>

  @if (filtered_metrics().length === 0) {
    <p class="empty-state">No hay métricas disponibles.</p>
  } @else {
    <div class="metrics-grid">
      @for (metric of filtered_metrics(); track metric.id) {
        <button type="button" class="metric-card" [class.metric-card-selected]="metric.is_selected" (click)="selectMetric(metric)">
          <span class="metric-card-title">{{ metric.title }}</span>
          <div class="metric-card-body">
            @if (metric.show_chart && metric.chart) {
              <div class="chart-wrap">
                <apx-chart
                  [series]="$any(metric.chart).series"
                  [chart]="$any(metric.chart).chart"
                  [xaxis]="$any(metric.chart).xaxis"
                  [stroke]="$any(metric.chart).stroke"
                  [tooltip]="$any(metric.chart).tooltip"
                  [dataLabels]="$any(metric.chart).dataLabels"
                  [labels]="$any(metric.chart).labels"
                  [legend]="$any(metric.chart).legend"
                  [colors]="$any(metric.chart).colors"
                  [fill]="$any(metric.chart).fill"
                  [grid]="$any(metric.chart).grid"
                  [plotOptions]="$any(metric.chart).plotOptions"
                  [yaxis]="$any(metric.chart).yaxis"
                ></apx-chart>
              </div>
            } @else if (metric.show_simple) {
              <div class="simple-value">
                <span class="simple-value-number">{{ metric.simple_value }}</span>
                @if (metric.simple_units) {
                  <span class="simple-value-units">{{ metric.simple_units }}</span>
                }
              </div>
            } @else {
              <span class="no-data">Sin datos</span>
            }
          </div>
        </button>
      }
    </div>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">Cancelar</button>
</div>
